import axios from 'axios';
// import https from 'https';

// const httpsAgent = new https.Agent({
//     rejectUnauthorized: false, // (NOTE: this will disable client verification)
//   }) 

const instance = axios.create({
    // httpsAgent:httpsAgent,
    // baseURL:'http://localhost:7071/api/',
    // baseURL: 'https://dataio-uiconfigurator-api.azurewebsites.net/api/',
    baseURL: 'https://pact-uiconfigurator-api.azurewebsites.net/api/',
 
});
// instance.get('https://dataio-uiconfigurator-api.azurewebsites.net/api/');
instance.defaults.headers.common['Authorization'] = 'Auth Token'
export default instance;